<template lang="pug">
  div.item-play-sound.f.fm
    //- div.mute-icon.f.fh.mr8
      v-icon(@click="onToggleMute"
        size="18px") {{(isMute) ? 'mdi-volume-off' : 'mdi-volume-high' }}
    div.wrap-volume-controller.f.fh
      v-icon(@click="showSlider = !showSlider"
        size="18px") {{(isMute) ? 'mdi-volume-off' : 'mdi-volume-high' }}
      div(v-if="showSlider").wrap-slider
        //- div.label.f.fc.pl1
          span.block.text-center.fz14 {{volume}}
        v-slider(v-model="volume" min="0" max="1" step="0.1"
          :color="pallete.$active_color" vertical height="80px")
    div
      //- div(@click="onToggleIcon"
        :class="{'active': showingSounds}").toggle-icon.f.fh.mr8
        v-icon(size="18px") mdi-plus
      div(v-for="(item, index) in sounds"
        :class="{'shown': showingSounds}"
        :style="`left: ${(showingSounds) ? (36 + 10) + (12 * index) + (20 * index) : 64}px !important;`"
        ).wrap-sound.f.fh.mr8
        span(@click="playSound(index)"
          :class="{'playing': item.isPlaying}").play-btn.fz20.cursor-pointer {{item.emoji}}
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.item-play-sound {
  position: relative;
  width: 100%;
  max-width: 340px;
  // .mute-icon {
  //   width: 32px;
  //   height: 32px;
  //   border-radius: 50%;
  //   background: $active_color;
  //   filter: $drop_shadow;
  // }
  .wrap-volume-controller {
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: $active_color;
    filter: $drop_shadow;
    
    .wrap-slider {
      position: absolute;
      bottom: calc(100% + 40px);
      width: 8px;
      height: 80px;
      // width: 160px;
      .label {
        position: absolute;
        width: 100%;
        bottom: 116px;
        // bottom: calc(100% + 18px);
      }
    }
  }
  .toggle-icon {
    position: relative;
    z-index: 2;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: $active_color;
    filter: $drop_shadow;

    transition: all 400ms $ease_out_expo;
    transform: rotate(0deg);
    &.active {
      transform: rotate(45deg);
    }
  }
  .wrap-sound {
    position: absolute;
    z-index: 1;
    top: 0;
    transition: all 400ms $ease_out_expo;    
    height: 100%;
    opacity: 0;
    &.shown {
      opacity: 1.0 !important;
    }
    .play-btn {
      &.playing {
        opacity: 0.5;
        cursor: none;
        pointer-events: none;
      }
    }
  }
}
</style>

<script>
import database from '@/database'
import { emortSounds } from '@/components/utils/sounds'

export default {
  data () {
    return {
      sounds: [],
      showingSounds: true,
      isMute: false,
      volume: 0.5,
      showSlider: false
    }
  },
  // computed: {
  //   sounds () {
  //     return { ...sounds, isPlaying: false}
  //   }
  // },
  props: {
    me: {
      type: Object,
      required: true
    }
  },
  watch: {
    volume () {
      this.isMute = this.volume === 0.0
    }
  },
  created () {
    this.sounds = emortSounds.map(e => {
      return { ...e, isPlaying: false }
    })
    // this.preloadSounds()

    // this.autoEmotionForDemo()
    // setInterval(this.autoEmotionForDemo, 6000)
  },
  // mounted () {
  //   // for (let i=0; i < 100; i++) {
  //   //   this.autoEmotionForDemo()
  //   // }
  // },
  methods: {
    // async autoEmotionForDemo () {
    //   await this.sleep(Math.floor(Math.random() * 1000))
    //   const indexes = [0, 1, 2, 3, 4, 5]
    //   const i = indexes[Math.floor(Math.random() * indexes.length)]
    //   this.playSound(i)
    // },
    onToggleMute () {
      this.isMute = !this.isMute
      if (this.isMute) this.$emit('playAllSoundsForPermission')
    },
    onToggleIcon () {
      this.showingSounds = !this.showingSounds
      if (this.showingSounds) this.$emit('playAllSoundsForPermission')
    },
    async playSound (index) {
      if (this.sounds[index].isPlaying) return
      this.sounds[index].isPlaying = true

      const msgObj = {
        createdBy: this.me.id,
        createdAt: new Date(),
        createdFrom: this.me.pos,
        class: 'sound',
        type: this.sounds[index].id,
        slide: this.$route.params.slideId
      }

      await database.slideCollection()
        .sendMessage(this.$route.params.slideId, msgObj)
      // await database.userCollection().sendMessage(this.me.id, msgObj)

      // this.sounds[index].audio.play()
      // await database.userCollection().update(this.me.id, {
      //   playingSound: { id: this.sounds[index].id, playedAt: new Date() }
      // })

      await this.sleep(this.sounds[index].playingDuration)
      this.sounds[index].isPlaying = false
    }
  }
}
</script>